import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@atlaskit/tooltip';
import { routePaths } from '@css-xp/ppc-constants';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { NoData } from './no-data';
import './org-name-link.scss';

export interface OrgNameLinkProps {
  orgName?: string | null;
  orgId?: string | null;
  txaId?: string | null;
  NoDataFallback?: JSX.Element;
}

export const OrgNameLink = ({ orgName, orgId, txaId, NoDataFallback }: OrgNameLinkProps) => {
  const defaultStyleClasses = 'line-clamp org-name-link';

  if (!orgName || orgName === '') {
    return NoDataFallback ?? <NoData />;
  }

  if (!txaId) {
    return (
      <Tooltip content={orgName} tag="span" position="bottom-start">
        <span className={defaultStyleClasses} data-testid={`org-name-url-${orgId ?? orgName}`}>
          {orgName}
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip content={orgName} tag="span" position="bottom-start">
      <Link
        className={defaultStyleClasses}
        data-testid={`org-name-url-${orgId ?? orgName}`}
        to={getRouteUrl(routePaths.organisationDetails, {
          txaId,
          organisationId: orgId ?? '',
        })}
        onClick={(e) => e.stopPropagation()}
      >
        {orgName}
      </Link>
    </Tooltip>
  );
};
